<template>
  <el-button
    v-bind="$attrs"
    :disabled="isDisabled"
    :loading="isLoading"
    :size="size"
    @click="handleClick"
  >
    <span class="rt-button-text">
      <rt-icon v-if="iconName" :name="iconName" :size="iconSize" />
      <slot />
    </span>
  </el-button>
</template>

<script>
export default {
  name: 'RtButton',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconName: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    iconSize: {
      type: String,
      default: '14'
    },

    click: Function,

    // eslint-disable-next-line vue/require-prop-types
    tagData: {
      required: false
    }
  },
  data() {
    return {
      isDisabled: this.disabled,
      isLoading: this.loading
    };
  },
  methods: {
    async handleClick(event) {
      if (
        this.click &&
        Object.prototype.toString.call(this.click) === '[object Function]'
      ) {
        try {
          this.isDisabled = true;
          this.isLoading = true;
          await this.click();
        } catch (error) {
        } finally {
          this.isDisabled = false;
          this.isLoading = false;
        }
      } else {
        this.$emit('click', event, this.tagData);
      }
    }
  }
};
</script>

<style lang="less">
.el-button--default span.rt-button-text {
  color: #6388c2;
}
span.rt-button-text {
  display: flex;
  align-items: center;
  .rt-icon {
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// rtButton.vue?7c2d871e